module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"color":"Цвет","opacity":"Непрозрачность"},"en":{"color":"Color","opacity":"Opacity"}}')
  delete Component.options._Ctor
}
